import { render } from "./soal-menjodohkan.vue?vue&type=template&id=4374269f&scoped=true"
import script from "./soal-menjodohkan.vue?vue&type=script&lang=js"
export * from "./soal-menjodohkan.vue?vue&type=script&lang=js"

import "./soal-menjodohkan.vue?vue&type=style&index=0&id=4374269f&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4374269f"]])

export default __exports__